import React from "react";
import "./Clock.scss";

class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countDay: 0,
      countHour: 0,
      countMinutes: 0,
      countSecond: 0,
      countDownDate: new Date(this.props.deadline)
    };
  }
  getTimeDifference(countDownDate, nowDate) {
    let distanceDate = countDownDate - nowDate;
    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distanceDate / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distanceDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distanceDate % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distanceDate % (1000 * 60)) / 1000);
    //console.log(days, countDownDate, nowDate);
    return distanceDate < 0 ? {days:0,hours:0,minutes:0,seconds:0} : { days, hours, minutes, seconds };
  }
  addZero(num) {
    return num.toString().length > 1 ? num : "0" + num;
  }
  tick() {
    let {
      days: countDay,
      hours: countHour,
      minutes: countMinutes,
      seconds: countSecond
    } = this.getTimeDifference(this.state.countDownDate, Date.now());

    this.setState({
      countDay,
      countHour,
      countMinutes,
      countSecond
    });

    this.timeId = setTimeout(() => {
      this.tick();
    }, 1000);
  }
  static getDerivedStateFromProps(props, state) {
    return { a: 1 };
  }
  componentDidMount() {
    this.tick();
  }
  componentWillUnmount() {
    clearTimeout(this.timeId);
  }

  render() {
    return (
      <div className="countDownClock flex-center py-4">
        <span>倒计时：</span>
        <span className="mr-1 mr-xl-3">
          <strong className="mr-2">{this.addZero(this.state.countDay)}</strong>天
        </span>
        <span className="mx-1 mx-xl-3">
          <strong className="mr-2">{this.addZero(this.state.countHour)}</strong>时
        </span>
        <span className="mx-1 mx-xl-3">
          <strong className="mr-2">{this.addZero(this.state.countMinutes)}</strong>分
        </span>
        <span className="mx-1 mx-xl-3">
          <strong className="mr-2">{this.addZero(this.state.countSecond)}</strong>秒
        </span>
      </div>
    );
  }
}

export default Clock;
